<template>
<v-list-tile v-if="geo" @click="plan">
	<v-list-tile-action>
		<v-icon small>fa-map-signs</v-icon>
	</v-list-tile-action>
	<v-list-tile-content>
		<v-list-tile-title small>Plan</v-list-tile-title>
		<v-list-tile-sub-title small>Plan an itinerary with an external service</v-list-tile-sub-title>
	</v-list-tile-content>
</v-list-tile>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmRowActionPlan",

	props: {
		row: Object
	},

	computed: {
		...Vuex.mapState({ user: (state) => state.user.user }),

		geo () {
			return this.row.entity.geo();
		}
	},

	methods: {
		plan () {
			// TODO
			console.log("PLAN ACTION HANDLER");
		}
	}
};

</script>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionPlan.vue